import { createI18n } from 'vue-i18n';
import { useI18nStore } from './stores/i18nStore';
import { ref, watch } from 'vue';
import { logger } from '@/utils/logger';

export function createI18nInstance() {
    const i18nStore = useI18nStore();
    const locale = ref(i18nStore.locale);

    const i18n = createI18n({
        legacy: false,
        locale: locale.value,
        fallbackLocale: 'en',
        messages: i18nStore.messages,
    });

    watch(() => i18nStore.locale, (newLocale) => {
        logger.log("locale changed: " + newLocale);
        locale.value = newLocale;
        i18n.global.locale.value = newLocale;
    });

    watch(() => i18nStore.messages, (newMessages) => {
        Object.keys(newMessages).forEach(lang => {
            i18n.global.setLocaleMessage(lang, newMessages[lang]);
        });
    }, { deep: true, immediate: true, flush: 'sync' });

    return i18n;
}
